import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["drawer", "overlay"]

  toggle() {
    this.drawerTarget.classList.toggle("-translate-x-full")
    this.drawerTarget.classList.toggle("translate-x-0")
    this.overlayTarget.classList.toggle("hidden")
  }

  close() {
    this.drawerTarget.classList.remove("translate-x-0")
    this.drawerTarget.classList.add("-translate-x-full")
    this.overlayTarget.classList.add("hidden")
  }
}
